
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { FormValid } from '@/config'
import config from '@/config'
@Component({
  name: 'Market',
  components: {},
})
export default class Market extends Vue {
  @Action('good/pay') private payMoney: any
  @Action('good/getGoodUrl') private getGoodUrl: any
  @Action('good/getGoodData') private getGoodData: any
  @Getter('role') private role!: any
  @Getter('id') private id!: any
  @Getter('roleSave') private roleSave!: any
  @Action('good/createGoodData') private createGoodData: any
  orderRules = {
    consigneeName: [
      {
        required: true,
        message: '请输入',
        trigger: 'blur',
      },
      { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' },
    ],
    consigneeMobile: [
      {
        required: true,
        message: '请输入',
        trigger: 'blur',
      },
      { validator: FormValid.phone },
    ],
    deliveryMethod: [
      {
        required: true,
        message: '请输入',
        trigger: 'change',
      },
    ],
    consigneeDetail: [
      {
        required: true,
        message: '请输入',
        trigger: 'blur',
      },
      { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
    ],
    remark: [],
  }
  visible: boolean = false
  img: any = ''
  name: string = ''
  imagesUrl: string = ''
  describe: string = ''
  introduce: string = ''
  price: any = ''
  item: any = {}
  payH: any = ''
  goodId: any = this.$route.query.goodId
  orderNumber: any = ''
  state = 0
  priceList = []
  visible_user = false
  orderForm = {}
  showUser() {
    this.visible_user = true
  }
  hideUser() {
    this.visible_user = false
  }
  purchase() {
    if (!this.id) {
      const options: any = this.$route.query
      this.$router.push({
        name: 'Login',
        params: {
          beforePath: this.$route.path,
          beforeOption: options,
        },
      })
      return this.$message.warning('请先登录')
    }
    if (this.roleSave != 1 || !this.roleSave) {
      this.$router.push({ path: `/${this.role}/authern` })
      return this.$message.warning('请先实名')
    }
    let item = this.item
    const options: any = {
      goodsId: item.id,
      specificationPrice: this.price,
      ...this.orderForm,
    }
    this.visible = false
    ;(this.$refs as any).user_info.validate((valid: any) => {
      if (valid) {
        this.createGoodData(options)
          .then(({ code, data }: any) => {
            if (code === 0) {
              this.orderNumber = data.orderNumber
              this.hideUser()
            }
            return data
          })
          .then(() => this.toPay())
      }
    })
  }
  created() {
    this.getData()
  }
  toPay() {
    const returnUrl = location.href
    this.payMoney({ orderId: this.orderNumber, returnUrl }).then(
      ({ request }: any) => {
        const { response } = request
        // this.payH = data;
        if (response) {
          let divForm = document.getElementsByTagName('div')
          if (divForm.length) {
            document.body.removeChild(divForm[0])
          }
          const div = document.createElement('div')
          div.innerHTML = response // data就是接口返回的form 表单字符串
          document.body.appendChild(div)
          // document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
          document.forms[0].submit()
        }
      }
    )
  }
  getData() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    this.getGoodData({ id: this.goodId })
      .then(async ({ code, data, msg }: any) => {
        if (code === 0) {
          this.item = data
          this.name = data.commodityName
          this.describe = data.commodityIntroduce
          this.imagesUrl = await this.getGoodUrl(data.commodityMainImgae)
          this.introduce = data.commodityDetail
          this.priceList = data.boList
          this.price = data.boList[0].specificationPrice
          // const beginDate = data.discountStartTime
          // 	? new Date(data.discountStartTime).getTime()
          // 	: null;
          // const endDate = data.discountStopTime
          // 	? new Date(data.discountStopTime).getTime()
          // 	: null;
          // const currentDate = new Date().getTime();
          // if (
          // 	(beginDate ? currentDate >= beginDate : false) &&
          // 	(endDate ? currentDate <= endDate : true)
          // ) {
          // 	this.price = (data.discount || 1) * data.price;
          // } else {
          // 	this.price = data.price || 0;
          // }
        }
      })
      .finally(() => loading.close())
  }
}
